import React from 'react';
import BaseSvg from '../Icon/BaseSvg';
import { LogoSvgProps } from '../Icon/icon';

export default function LogoIconSvg(props: LogoSvgProps): React.ReactElement {
  const {
    id,
    children,
    dmId,
    fill,
    pointerEvents,
    size,
    viewBox,
    ...otherProps
  } = props;

  return (
    <BaseSvg
      id={id}
      data-designsystem
      dmId={dmId}
      fill={fill}
      pointerEvents={pointerEvents}
      width={size}
      height="100%"
      viewBox={viewBox}
      {...otherProps}>
      {children}
    </BaseSvg>
  );
}
